<div class="row pb-3">
  <div class="col-1">
    <rask-arbetsorder-bulk-context-menu
      [data]="selectedArbetsorderList">
    </rask-arbetsorder-bulk-context-menu>
  </div>
  <div class="col-4">
    <div aid="arbetsorder-antal" class="arbetsorder-antal">
      <span>{{arbetsorderList.length}} Arbetsorder</span>
    </div>
  </div>
  <div class="col-5">
    <rask-checkbox
      text="Visa enbart valda {{ selectedArbetsorderList.length ? '('+selectedArbetsorderList.length+')' : ''}}"
      [disabled]="selectedArbetsorderList.length === 0 && !showOnlySelected"
      [ngModel]="showOnlySelected"
    (ngModelChange)="toggleShowOnlySelected()">></rask-checkbox>
  </div>
  <div class="col-2">
    <span style="float: right; cursor: pointer;"
      (click)="toggleMapTheaterMode()">
      <a>
        @if (!mapTheatherModeEnabled) {
          <i class="fas fa-chevron-double-left"></i>
        }
        @if (mapTheatherModeEnabled) {
          <i class="fas fa-chevron-double-right"></i>
        }
      </a>
    </span>
  </div>
</div>